


jQuery( document ).ready(function() {
  function readyMcafee(){
    if($("#mfesecure-ts-image").length){
      $("#mfesecure-ts-image").appendTo(".footer-left #custom-bundle-badges-container");
    }else{
      setTimeout(readyMcafee, 100); 
    }
  }
  readyMcafee();	


  $('#product-image-slider').magnificPopup({
    delegate: 'a',
    type: 'image',
    mainClass: 'mfp-img-mobile mobile-magnific-wrapper',
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    },
    callbacks: {
      close: function() {
        $("html").css("overflow-y","auto");
      },
      open: function() {

        $("html").css("overflow-y","hidden");
      },
      buildControls: function() {
        // re-appends controls inside the main container
        if(this.arrowLeft != undefined) {
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
        }
      },
      imageLoadComplete: function() {
        //     $(".mfp-content").outerHeight();
        //     $(".mfp-content").outerWidth();
        var width = $(".mfp-img").outerWidth()/2 - $(window).outerWidth()/2;
        var height = $(".mfp-img").outerHeight()/2 - $(window).outerHeight()/2;
        $(".mfp-container").animate({
          scrollTop:height,
          scrollLeft:width
        }, 1);
      }
    }
  });

  $('.size_chart_popup_link').magnificPopup({
    type: 'inline',
    preloader: false,
    closeBtnInside: true,
  });


  $(".header-search-submit").on("mouseover", function(e){
    e.stopPropagation();
    e.preventDefault();  
    $("form.header-search-form").toggleClass("visibleForm").find('.header-search-field');
    $('.visibleForm .header-search-field').focus();
  });

  if($(".page_with_popup").length && true ){
    discountOverlay();
  }
  if($(".template-index").length && false){
    homePagePopupOverlay();
  }




  //     /* REGIONAL SETTINGS */
  //     // get location by ip code: https://help.shopify.com/themes/customization/store/get-customers-location

  //     // Set variables
  //     var americaCodes = ['AI','AG','AW','BS','BB','BZ','BM','BQ','VG','CA','KY','CR','CU','CW','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','PM','MS','CW','KN','NI','PA','PR','SX','KN','LC','PM','VC','TT','TC','US','VI','AR','BO','BR','CL','CO','EC','FK','GF','GY','PY','PE','SR','UY','VE'];
  //     var northAmericaCodes = ['AI','AG','AW','BS','BB','BZ','BM','BQ','VG','CA','KY','CR','CU','CW','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','PM','MS','CW','KN','NI','PA','PR','BQ','BQ','SX','KN','LC','PM','VC','TT','TC','US','VI'];
  //     var southAmericaCodes = ['AR','BO','BR','CL','CO','EC','FK','GF','GY','GY','PY','PE','SR','UY','VE'];
  //     var africaCodes = ['DZ','AO','SH','BJ','BW','BF','BI','CM','CV','CF','TD','KM','CG','CD','DJ','EG','GQ','ER','ET','GA','GM','GH','GN','GW','CI','KE','LS','LR','LY','MG','MW','ML','MR','MU','YT','MA','MZ','NA','NE','NG','ST','RE','RW','ST','SN','SC','SL','SO','ZA','SS','SH','SD','SZ','TZ','TG','TN','UG','CD','ZM','TZ','ZW'];
  //     var asiaCodes = ['AF','AM','AZ','BD','BT','BN','KH','CN','CX','CC','IO','GE','HK','IN','ID','JP','KZ','KG','LA','MO','MY','MV','MN','MM','NP','KP','PK','PS','PH', 'SG','KR','LK','TW','TJ','TH','TR','TM','UZ','VN'];
  //     var europeCodes = ['AL','AD','AT','BY','BE','BA','BG','HR','CY','CZ','DK','EE','FO','FI','FR','DE','GI','GR','HU','IS','IE','IM','IT','RS','LV','LI','LT','LU','MK','MT','MD','MC','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SE','CH','UA','GB','VA','RS'];
  //     var oceaniaCodes = ['AS','AU','NZ','CK','TL','FM','FJ','PF','GU','KI','MP','MH','UM','NR','NC','NZ','NU','NF','PW','PG','MP','WS','SB','TK','TO','TV','VU','UM','WF'];
  // 	var middleEastCodes = ['AE','SA','OM','QA','KW','BH','YE','IQ','IR','LB','JO','IL'];



  //   // Initial region checkRegionalSettings
  //     function checkRegionalSettings(){
  // //         var regionCookie = readCookie('regionCookie');
  // //         var regionLabelCookie = readCookie('regionLabelCookie');

  //       var regionCookie,
  //           regionLabelCookie;


  //         if( !regionCookie ){
  //             console.log('NO regionCookie, set it');
  //           	setAutomaticRegion();
  //         } else {
  //             // console.log('Has regionCookie');
  //             manageRegionClasses(regionCookie);
  //             discountOverlay();
  //         }

  //         if( !regionLabelCookie ){
  //             console.log('NO regionLabelCookie, set it');
  //             setAutomaticRegionLabel();
  //         } else {
  //             console.log('Has regionLabelCookie');
  //             setRegionlabel(regionLabelCookie);

  //         }
  //     }




  //     // set region by IP
  //     function setAutomaticRegion(){
  //         console.log('setAutomaticRegion()');

  //         // set default region and currency
  //         var autoRegion = 'america';
  //         var autoCurrency = 'USD';

  //         

  //         // get IP location
  //         jQuery.ajax( {
  //             url: '//freegeoip.net/json/',
  //             type: 'POST',
  //             dataType: 'jsonp',
  //             success: function(location) {

  //                 var ipLocation = location.country_code;

  //                 // ipLocation = 'AE'; // TEST IP

  //                 console.log('ipLocation: '+location.country_name+', '+ipLocation);

  //                 // on sucess set default region to 'dubai'
  //                 autoRegion = 'europe-africa-asia';
  //                 autoCurrency = 'AED';

  //                 var isAmericas = false;

  //                 // if country code is in the americas, set to 'us'
  //                 for( var x = 0; x < americaCodes.length ; x++ ){
  //                     if ( americaCodes[x] == ipLocation ) {
  //                         isAmericas = true;
  //                     }
  //                 }

  //                 if ( isAmericas ){
  //                     autoRegion = 'america';
  //                     autoCurrency = 'USD';
  //                    // setCurrency(autoCurrency);
  //                     setRegion(autoRegion);
  //                     discountOverlay();
  //                     console.log('Set automatic IP region to america');
  //                 } else {
  //                     setRegion(autoRegion);
  //                     discountOverlay();
  //                     discountOverlay();
  //                     console.log('Set automatic IP region to dubai');
  //                 }

  //             },
  //             error: function(){
  //                 console.log('Set default IP region to '+autoRegion);
  //                 //setCurrency(autoCurrency);
  //                 setRegion(autoRegion);
  //                 discountOverlay();
  //             }
  //         } );

  //     }

  //     function setAutomaticRegionLabel(){
  //         console.log('setAutomaticRegionLabel()');

  //         // set default region label
  //         var regionLabel = '';
  //         var firstLoadCurrency = 'USD';

  //         // get IP location
  //         jQuery.ajax( {
  //             url: '//freegeoip.net/json/',
  //             type: 'POST',
  //             dataType: 'jsonp',
  //             success: function(location) {

  //                 var ipLocation = location.country_code;
  //                 // ipLocation = 'AR'; // TEST IP

  //                 // if country code is in north americas
  //                 for( var x = 0; x < northAmericaCodes.length ; x++ ){
  //                     if ( northAmericaCodes[x] == ipLocation ) {
  //                         regionLabel = 'North America';
  //                         firstLoadCurrency = 'USD';

  //                     }
  //                 }

  //                 // if country code is in south americas
  //                 for( var x = 0; x < southAmericaCodes.length ; x++ ){
  //                     if ( southAmericaCodes[x] == ipLocation ) {
  //                         regionLabel = 'South America';
  //                        firstLoadCurrency = 'USD';
  //                     }
  //                 }

  //                 // if country code is in europe
  //                 for( var x = 0; x < europeCodes.length ; x++ ){
  //                     if ( europeCodes[x] == ipLocation ) {
  //                         regionLabel = 'Europe';
  //                        firstLoadCurrency = 'EUR';
  //                     }
  //                 }

  //                 // if country code is in asia
  //                 for( var x = 0; x < asiaCodes.length ; x++ ){
  //                     if ( asiaCodes[x] == ipLocation ) {
  //                         regionLabel = 'Asia';
  //                         firstLoadCurrency = 'HKD';
  //                     }
  //                 }

  //                 // if country code is in africa
  //                 for( var x = 0; x < africaCodes.length ; x++ ){
  //                     if ( africaCodes[x] == ipLocation ) {
  //                         regionLabel = 'Africa';
  //                         firstLoadCurrency = 'ZAR';
  //                     }
  //                 }

  //                 // if country code is in oceania
  //                 for( var x = 0; x < oceaniaCodes.length ; x++ ){
  //                     if ( oceaniaCodes[x] == ipLocation ) {
  //                         regionLabel = 'Oceania';
  //                         firstLoadCurrency = 'AUD';
  //                     }
  //                 }
  //                // if country code is in Middle East 
  //                 for( var x = 0; x < middleEastCodes.length ; x++ ){
  //                     if ( middleEastCodes[x] == ipLocation ) {
  //                         regionLabel = 'Middle East';
  //                         firstLoadCurrency = 'AED';
  //                     }
  //                 }



  //                 setRegionlabel(regionLabel);
  //                // setCurrency(firstLoadCurrency);
  //                 //cookieCurrency = firstLoadCurrency;
  //                 console.log('regionLabelCookie set: '+regionLabel);
  //             },
  //             error: function(){
  //                 console.log('region label: '+regionLabel);
  //             }
  //         } );

  //     }

  //     function setRegionlabel( regionLabel ){
  //         createCookie('regionLabelCookie',regionLabel,3650);
  //         jQuery('#region-label').text(regionLabel);      
  //     }

  //     

  //     function setRegion (selectedRegion){
  //         console.log('setRegion()');
  //         createCookie('regionCookie',selectedRegion,3650);
  //         manageRegionClasses(selectedRegion);

  //         
  //     }

  //     function manageRegionClasses(selectedRegion) {

  //         

  //         // set body classes

  //         siteLocation = 'us';

  //         if( selectedRegion == 'europe-africa-asia' ){
  //             siteLocation = 'dubai';
  //         }
  //         jQuery('body').removeClass('location-us location-dubai').addClass('location-'+siteLocation); 

  //         // set nav classes
  //         jQuery('.nav-link-region').attr('class','header-nav-icon-link nav-link-region '+selectedRegion );
  //         jQuery('.nav-link-region + .sub-menu li').removeClass('active');
  //         jQuery('.nav-link-region + .sub-menu').find('.'+selectedRegion).addClass('active');

  // set hero classes
  setHeroSliderLinks('dubai');

  //     }

  //     

  //     function manageCollectionsUrl( selectedRegion ){
  //         console.log('manageCollectionsUrl(): to '+selectedRegion);

  //         var currentUrl = window.location.href;
  //         var updatedUrl = '';

  //         console.log('currentUrl: '+ currentUrl);

  //         if( selectedRegion == 'america' ){
  //             updatedUrl = currentUrl.replace('-dubai','');
  //         } else if(currentUrl.indexOf("-dubai") == -1) {
  //             updatedUrl = currentUrl.replace( collectionToLoad , collectionToLoad+'-dubai');
  //         }

  //         // console.log('fixedUrl: '+ updatedUrl);
  //         window.location.href = updatedUrl;
  //     }

  //     jQuery(document).on('click','a.region-link',function(event){

  // 		event.preventDefault();
  // //         jQuery('body').removeClass('mobile-navigation');

  // //         var thisLink = jQuery(this);
  // //         var selectedRegion = thisLink.data('region');
  // // 		var selectedRegionLabel = thisLink.data('region-label');
  // //         var selectedCurrency = thisLink.data('currency');
  // //         var regionLabel = thisLink.text();

  // //         setCurrency(selectedCurrency);
  // //         setRegion(selectedRegion);
  // //         setRegionlabel(regionLabel);

  // //         if( typeof onCollectionPage != 'undefined' && onCollectionPage ){
  // //             manageCollectionsUrl( selectedRegion );
  // //         }

  // //         console.log('region-link - selectedRegion: '+selectedRegion+', selectedRegionLabel: '+selectedRegionLabel+', selectedCurrency: '+selectedCurrency);

  //         

  // 	});


  






  /* SET HERO SLIDERS LINKS */
  function setHeroSliderLinks(siteLocation){
    // console.log('setHeroSliderLinks('+siteLocation+')');
    jQuery('.slide-item, .featured-story').each( function(){
      // get this link element
      var thisLink = jQuery(this);
      // if this link has the proper data attr, set it as the href
      if( typeof thisLink.data('dubai-url') != 'undefined' ) {

        thisLink.attr('href' , thisLink.data('dubai-url') ).addClass('has-link');
      }
    });        
  }


  jQuery(document).on('click','.slide-item, .featured-story',function(event){
    if( jQuery(this).attr('href')  == '#' ){
      event.preventDefault();
    }
  });





  /* RETURN BROWSER DIMENSIONS */
  function getBrowserDimensions (reqDimension) {
    switch(reqDimension)
    {
      case 'height':
        return window.innerHeight || document.documentElement.clientHeight;
        break;
      case 'width':
        return window.innerWidth || document.documentElement.clientWidth;
        break;
      default:
    } 
  }


  var bloomrLogo = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 250" enable-background="new 0 0 1000 250" xml:space="preserve"><path fill="#40403e" d="M496.239,246.562c-1.488-0.681-2.875-1.488-4.116-2.391c-4.8-3.501-8.387-8.12-10.649-13.718c-2.225-5.492-3.614-11.83-4.133-18.858c-0.037-0.382-0.059-0.768-0.085-1.165c-0.032-0.498-0.352-0.932-0.824-1.111c-0.47-0.183-0.999-0.067-1.36,0.291c-4.407,4.357-9.52,7.83-15.199,10.328c-3.563,1.56-7.303,2.686-11.128,3.333c-2.132,0.387-4.395,0.619-6.744,0.696c-1.304,0.067-2.667,0.063-4.044,0c-2.335-0.078-4.602-0.31-6.748-0.701c-3.8-0.637-7.541-1.763-11.129-3.328c-5.718-2.521-10.823-6-15.176-10.328c-0.357-0.358-0.888-0.474-1.36-0.295c-0.47,0.179-0.792,0.618-0.824,1.116l-0.083,1.179c-0.528,7.014-1.922,13.352-4.134,18.844c-2.271,5.594-5.861,10.212-10.673,13.718c-1.229,0.903-2.613,1.71-4.109,2.386c-0.591,0.271-0.888,0.928-0.693,1.546c0.171,0.542,0.671,0.894,1.222,0.894c0.077,0,0.159-0.009,0.235-0.019c4.296-0.802,8.478-1.927,12.431-3.348c4.7-1.7,9.127-3.709,13.147-5.975c1.355-0.764,2.535-1.464,3.608-2.15c1.435-0.913,2.719-1.792,3.915-2.676c6.444-3.802,13.977-5.719,22.397-5.719c8.409,0,15.913,1.898,22.299,5.666c1.355,0.98,2.732,1.917,4.087,2.772c1.183,0.749,2.385,1.463,3.578,2.131c4.053,2.275,8.465,4.279,13.104,5.951c3.971,1.42,8.15,2.545,12.416,3.348c0.638,0.121,1.265-0.256,1.459-0.87C497.126,247.49,496.828,246.828,496.239,246.562z"></path><path fill="#40403e" d="M187.632,145.538c-11.552-8.743-28.377-14.129-51.233-16.36c42.129-4.98,62.648-22.394,62.648-53.034	c0-37.547-30.29-56.586-90.027-56.586H1.282C0.576,19.557,0,20.13,0,20.834v2.548c0,0.705,0.576,1.275,1.282,1.275c30.675,0,33.412,8.161,33.412,31.473v154.285c0,23.317-2.737,31.471-33.412,31.471c-0.707,0-1.282,0.57-1.282,1.28v2.546	c0,0.709,0.576,1.28,1.282,1.28h115.041c59.741,0,90.031-20.389,90.031-60.588C206.354,168.444,200.231,155.073,187.632,145.538zM73.781,25.021h32.684c17.9,0,31.5,5.477,40.416,16.271c9.303,11.27,11.256,25.573,11.256,35.576c0,15.192-4.15,27.201-12.333,35.693c-9.177,9.516-23.27,14.341-41.898,14.341H73.781V25.021z M152.284,224.69	c-9.483,11.014-23.562,16.833-40.706,16.833H73.781V132.365h34.144c18.913,0,33.568,5.048,43.558,15.003c9.13,9.096,13.958,22.215,13.958,37.938C165.441,200.842,160.769,214.831,152.284,224.69z"></path><path fill="#40403e" d="M287.384,241.887c-20.494,0-26.108-4.498-26.108-20.917V2.276c0-0.364-0.157-0.715-0.433-0.957c-0.274-0.239-0.64-0.357-1.002-0.309l-60.626,7.277c-0.643,0.077-1.129,0.621-1.129,1.263v2.188c0,0.706,0.577,1.275,1.282,1.275c20.256,0,26.112,4.775,26.112,21.283V220.97c0,16.419-5.613,20.917-26.112,20.917c-0.706,0-1.282,0.57-1.282,1.28v2.546c0,0.709,0.577,1.28,1.282,1.28h88.016c0.71,0,1.286-0.57,1.286-1.28v-2.546C288.67,242.457,288.095,241.887,287.384,241.887z"></path><path fill="#40403e" d="M354.349,95.292c-18.347,1.116-35.63,8.043-48.666,19.515c-16.122,14.183-24.646,34.036-24.646,57.405c0,47.745,34.753,72.862,69.192,76.577c0.045,0.004,0.092,0.009,0.141,0.009c0.617,0,1.158-0.449,1.261-1.067c0.114-0.666-0.319-1.304-0.978-1.459c-10.33-2.352-18.5-9.144-24.272-20.191c-6.664-12.757-10.042-30.881-10.042-53.869c0-22.959,3.383-41.025,10.05-53.69c6.472-12.308,15.957-19.264,28.189-20.684c0.688-0.082,1.187-0.701,1.126-1.386C355.641,95.76,355.04,95.253,354.349,95.292z"></path><path fill="#40403e" d="M574.871,114.807c-13.073-11.472-30.335-18.404-48.605-19.525c-0.684-0.038-1.294,0.468-1.354,1.16c-0.061,0.69,0.437,1.304,1.127,1.381c12.108,1.42,21.509,8.386,27.947,20.703c6.635,12.685,9.996,30.746,9.996,53.686c0,21.751-3.049,39.204-9.063,51.875c-5.904,12.433-14.532,19.944-25.651,22.321c-0.661,0.14-1.098,0.773-0.998,1.439c0.094,0.628,0.64,1.087,1.265,1.087c0.039,0,0.078,0,0.117-0.005c21.442-1.869,39.512-10.974,52.255-26.33c11.441-13.796,17.744-31.688,17.744-50.387C599.649,148.876,591.083,129.023,574.871,114.807z"></path><path fill="#40403e" d="M976.44,93.06c-9.987,0-20.158,4.98-29.406,14.395c-6.761,6.888-12.862,15.999-17.521,26.099V95.064	c0-0.362-0.16-0.71-0.427-0.951c-0.281-0.247-0.643-0.358-1.009-0.314l-60.26,7.274c-0.643,0.083-1.127,0.624-1.127,1.271v2.184	c0,0.71,0.574,1.28,1.279,1.28c20.256,0,26.115,4.772,26.115,21.283v93.518c0,15.873-5.488,20.834-23.429,21.25	c-18.127-0.401-23.368-5.086-23.368-20.887v-78.963c0-30.422-15.635-48.58-41.82-48.58c-26.7,0-47.056,19.496-57.719,30.369	c-5.013-19.341-19.397-30.369-39.791-30.369c-23.327,0-41.863,14.883-55.692,28.721V95.064c0-0.362-0.158-0.71-0.432-0.951c-0.274-0.247-0.643-0.363-1.006-0.314l-59.895,7.274c-0.642,0.083-1.124,0.624-1.124,1.271v2.184c0,0.71,0.572,1.28,1.277,1.28c20.503,0,26.111,4.497,26.111,20.916v94.247c0,16.419-5.608,20.917-26.111,20.917c-0.705,0-1.277,0.57-1.277,1.28v2.546c0,0.709,0.572,1.28,1.277,1.28h86.556c0.71,0,1.282-0.57,1.282-1.28v-2.546c0-0.71-0.572-1.28-1.282-1.28c-19.399,0-25.012-4.696-25.012-20.917v-91.909c9.495-9.767,21.352-19.616,37.431-19.616c16.34,0,24.281,10.052,24.281,30.741v80.785c0,16.221-5.606,20.917-25.014,20.917c-0.708,0-1.28,0.57-1.28,1.28v2.546c0,0.709,0.572,1.28,1.28,1.28h86.192c0.705,0,1.28-0.57,1.28-1.28v-2.546c0-0.71-0.575-1.28-1.28-1.28c-19.921,0-25.378-4.498-25.378-20.917v-78.963c0-3.241-0.393-6.501-0.744-9.376c-0.108-0.874-0.211-1.72-0.298-2.536c10.481-10.781,22.415-20.65,38.473-20.65c16.112,0,24.284,10.342,24.284,30.741v80.785c0,16.221-5.614,20.917-25.017,20.917c-0.71,0-1.282,0.57-1.282,1.28v2.546c0,0.709,0.572,1.28,1.282,1.28h170.239c0.71,0,1.282-0.57,1.282-1.28v-2.546c0-0.71-0.572-1.28-1.282-1.28c-18.809,0-27.2-3.068-27.2-21.279v-76.886c4.686-10.883,13.977-23.756,26.466-28.592c-0.293,5.777,1.648,11.458,5.476,15.858c4.187,4.807,10.182,7.565,16.445,7.565c11.984,0,21.731-10.042,21.731-22.379C1000,105.04,992.626,93.06,976.44,93.06z"></path><path fill="#8da58b" d="M438.091,144.997c0.159,0.367,0.313,0.724,0.468,1.092l0.264,0.613c0.204,0.459,0.669,0.763,1.181,0.763h0.025c0.522-0.005,0.984-0.328,1.172-0.816c0.229-0.584,0.441-1.149,0.684-1.662c3.398-7.594,7.816-14.66,13.14-21.003	c0.325-0.392,0.395-0.937,0.163-1.386c-6.349-12.709-10.816-26.056-13.261-39.692c-0.118-0.647-0.223-1.295-0.328-1.932	l-0.168-1.087c-0.103-0.609-0.64-1.063-1.264-1.063h-0.009c-0.621,0-1.161,0.464-1.257,1.083l-0.102,0.627c-0.121,0.778-0.249,1.575-0.382,2.363c-2.488,13.733-7.008,27.176-13.417,39.962c-0.233,0.454-0.172,0.995,0.152,1.391C430.37,130.5,434.724,137.481,438.091,144.997z"></path><path fill="#8da58b" d="M437.235,161.797c0.213-0.918,0.417-1.821,0.623-2.71v-0.005c0.208-0.855,0.401-1.681,0.608-2.497c-0.624-2.043-1.327-4.058-2.112-6.039c-0.409-1.048-0.863-2.125-1.395-3.318c-2.886-6.443-6.527-12.496-10.832-17.988c-2.725-3.478-5.761-6.782-9-9.811c-8.439-7.917-18.515-14.332-29.949-19.065c-5.006-2.077-10.309-3.72-15.75-4.893c-0.623-0.126-1.253,0.217-1.47,0.816c-0.223,0.599,0.045,1.271,0.608,1.57c1.897,0.985,3.675,2.169,5.28,3.531c6.186,5.188,10.8,12.028,13.716,20.331c2.839,8.096,4.621,17.458,5.298,27.799c0.666,10.192,1,20.684,1,31.258	c0.01,0.141,0.172,3.464,2.314,8.695c1.915,4.638,4.369,8.859,7.28,12.56c0.949,1.188,1.942,2.319,2.935,3.367c3.743,3.927,8.09,7.135,12.953,9.564c0.204-0.376,0.41-0.749,0.604-1.116c0.206-0.376,0.404-0.749,0.598-1.125c9.292-17.66,12.889-33.842,15.819-47.005C436.662,164.367,436.951,163.067,437.235,161.797z"></path><path fill="#8da58b" d="M510.529,95.471c-5.418,1.164-10.717,2.806-15.754,4.893c-11.429,4.733-21.506,11.148-29.939,19.061c-3.178,2.98-6.135,6.188-8.792,9.55c-4.383,5.55-8.103,11.689-11.041,18.254c-0.299,0.676-0.617,1.439-0.922,2.28	c-0.025,0.068-0.051,0.141-0.076,0.208c-1.643,4.767-2.89,10.342-4.309,16.736c-0.033,0.146-0.07,0.281-0.102,0.436v0.01c-0.223,1.029-0.462,2.086-0.701,3.154c-2.846,12.627-6.632,27.683-15.231,44.068c-0.194,0.377-0.392,0.754-0.605,1.13c-0.187,0.372-0.392,0.754-0.604,1.13c2.927,1.198,5.944,2.078,8.996,2.614c0.112,0.023,0.233,0.043,0.35,0.063c2.018,0.372,4.146,0.584,6.292,0.652c0.675,0.034,1.34,0.048,2.024,0.048c0.599,0,1.188-0.014,1.725-0.048c2.181-0.068,4.309-0.281,6.282-0.647c0.143-0.024,0.28-0.044,0.356-0.067c3.417-0.585,6.785-1.609,10.019-3.034c5.723-2.517,10.801-6.067,15.092-10.564c1.057-1.125,2.048-2.265,2.938-3.396c2.928-3.72,5.372-7.937,7.27-12.531c2.155-5.231,2.31-8.559,2.317-8.748c0-10.521,0.332-21.013,0.992-31.196c0.684-10.39,2.458-19.737,5.296-27.809c2.921-8.308,7.536-15.153,13.708-20.331c1.625-1.362,3.401-2.546,5.292-3.531c0.561-0.299,0.822-0.971,0.604-1.57C511.782,95.688,511.152,95.335,510.529,95.471z"></path></svg>';





  /* OVERLAY */

  /* close overlay */
  jQuery(document).on('click','.overlay-close, .discount-continue',function(event){
    event.preventDefault();
    closeOverlay();
  });

  function closeOverlay(){
    jQuery('body').removeClass('overlay-open');
    jQuery('.overlay-outer').attr({'class':'overlay-outer','style':''});
    jQuery('#overlay').attr({'style':''});
  }

  function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  /* open overlay */
  function openOverlay(type){
    // clear overlay
    jQuery('.overlay-content').html('');
    jQuery('#overlay').removeClass('unclosable');
    var overlayHTML = '';


    switch ( type ){
      case 'region':
        jQuery('#overlay').addClass('unclosable');
        overlayHTML = regionHtml();
        break;
      case 'discount':         
        overlayHTML = $("#discount-overlay");          
        break;
    }

    // insert html

    var search_attr = window.location.search.substr(1);
    if(getCookie('show_modal') == undefined && search_attr != "e=n") {
      jQuery('.overlay-content').append(overlayHTML);
      jQuery('body').addClass('overlay-open');
      var show_date = new Date;
      show_date.setDate(show_date.getDate() + 14);
      show_date = show_date.toUTCString();
      document.cookie = 'show_modal=true; path=/; expires='+show_date;
    }


    // setup after opening
    //         switch ( type ){
    //             case 'discount':
    //             jQuery('#mc-embedded-subscribe-form-overlay').ajaxChimp({
    //                 callback: discountOverlaySignup
    //             });
    //             break;
    //         }

  }


  function openHomePagePopupOverlay(type) {
    // clear overlay
    jQuery('.overlay-content').html('');
    jQuery('#overlay').removeClass('unclosable');
    var overlayHTML = '';


    switch ( type ){
      case 'region':
        jQuery('#overlay').addClass('unclosable');
        overlayHTML = regionHtml();
        break;
      case 'discount':         
        overlayHTML = $("#home_page_popup_overlay");          
        break;
    }

    // insert html

    var search_attr = window.location.search.substr(1);
    if(getCookie('show_modal') == undefined && search_attr != "e=n") {
      jQuery('.overlay-content').append(overlayHTML);
 	  jQuery('body').addClass('overlay-open home_page_overlay_open');
      var show_date = new Date;
      show_date.setDate(show_date.getDate() + 14);
      show_date = show_date.toUTCString();
      document.cookie = 'show_modal=true; path=/; expires='+show_date;
    }
  }



  /* MOBILE MENU */

  /* menu toggle */
  jQuery(document).on('click','.mobile-menu-toggle', function(event){
    event.preventDefault();
    var overlay = jQuery('.mobile-navigation-container');
    var overlayInner = jQuery('.mobile-navigation-inner');

    // setup body
    jQuery('body').toggleClass('mobile-navigation');
    // show overlay & inner
    overlay.addClass('active');
    overlayInner.addClass('active');
  });
  jQuery(document).on('click',' #mobile-overlay', function(event){
    event.preventDefault();
    var overlay = jQuery('.mobile-navigation-container');
    var overlayInner = jQuery('.mobile-navigation-inner');

    // setup body
    jQuery('body').toggleClass('mobile-navigation');
    // show overlay & inner
    overlay.removeClass('active');
    overlayInner.removeClass('active');
  });


  /* submenu-links */
  jQuery(document).on('click','li.has-dropdown > a .dropdown-toggle, li.has-dropdown > a', function(event){
    if( getBrowserDimensions('width') < 768 ){
      event.preventDefault();
      $('li.has-dropdown').not($(this).closest('li.has-dropdown')).removeClass('show-dropdown');
      jQuery(this).closest('li.has-dropdown').toggleClass('show-dropdown');
    }
  });

  /* subsubmenu-links */
  jQuery(document).on('click','li.has-sub-dropdown > a', function(event){
    if( getBrowserDimensions('width') < 768 ){
      event.preventDefault();
      $('li.has-sub-dropdown').not($(this).closest('li.has-sub-dropdown')).removeClass('show-sub-dropdown');
      jQuery(this).closest('li.has-sub-dropdown').toggleClass('show-sub-dropdown');
    }
  });

  if( getBrowserDimensions('width') > 767 ){
   $('ul.header-nav li.has-sub-dropdown').hoverIntent(function() {
    $(this).addClass('show-sub-dropdown');
  }, function() {
    $(this).removeClass('show-sub-dropdown');
  });
   $('ul.header-nav li.has-sub-dropdown + .sub-menu-wrapper').hoverIntent(function() {
    $(this).addClass('hovered-sub-menu');
    $(this).prev("li.has-sub-dropdown").addClass('highlighted-dropdown');
  }, function() {
    $(this).removeClass('hovered-sub-menu');
    $(this).prev("li.has-sub-dropdown").removeClass('highlighted-dropdown');
  });
  }
  
  

  // currency link
  jQuery(document).on('click','li.has-dropdown .header-currency-region-link, li.has-dropdown .header-currency-region-link .dropdown-toggle', function(event){
    if( getBrowserDimensions('width') < 768 ){
      event.preventDefault();
      jQuery(this).closest('li.has-dropdown').toggleClass('show-dropdown');
    }
  });


  /* DESKTOP MENU */
  var imageHoverTimeout;
  jQuery('.image-hover-link').hover(
    function(){
      clearTimeout(imageHoverTimeout);
      console.log("here1");
      var thisWrapper = jQuery(this).closest('.sub-menu-main-image-wrapper');
      var thisImage = jQuery(this).data('image-url');
      thisWrapper.find('.sub-menu-image').css('background-image', 'url(' + thisImage + ')');
    },
    function(){
      var thisWrapper = jQuery(this).closest('.sub-menu-main-image-wrapper');
      var defaultImage = thisWrapper.find('.sub-menu-image').data('default-image');            
      imageHoverTimeout = setTimeout( function(){
        thisWrapper.find('.sub-menu-image').css('background-image', 'url(' + defaultImage + ')');
      } , 500);
    }
  );


  // SEARCH
  /* search toggle */

  /*
    jQuery(document).on('click','.header-search-toggle',function(event){
    	event.preventDefault();
    	// toggle form's active class
    	if( jQuery('.header-search-form').hasClass('active') ){
    		// active w. empty field, make inactive
    		if( jQuery('.header-search-field').val() == '' ) {
    			jQuery('.header-search-form').removeClass('active');
    		} else {
    			// active w. search term, submit
    			jQuery('.header-search-form').submit();
    		}
    	} else {
    		jQuery('.header-search-form').addClass('active');
    	}
    });


    jQuery(document).on('click','.header-search-field-clear',function(event){
    	event.preventDefault();
    	jQuery('.header-search-field').val('');
    });
    */



  jQuery(document).on('click','.header-search-submit',function(event){
    event.preventDefault();
    jQuery('.header-search-form').submit();
  });

  jQuery(document).on('click','.header-search-toggle, .header-search-field-clear',function(event){
    event.preventDefault();
    jQuery('.header-search-form').toggleClass('active');
  });


  // OWL SLIDERS
  var heroItemCount = $('#hero-slider').find('.slide-item').length;
  var heroLoop = false;
  if( heroItemCount > 1 ){
    heroLoop = true;
  }

  $('#hero-slider').owlCarousel({
    nav:true,
    items:1,
    singleItem: true,
    loop: heroLoop,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplaySpeed: 750
  })

  var productImageCount = $('#product-image-slider').find('.product-image-item').length;
  var productImageLoop = false;
  if( productImageCount > 1 ){
    productImageLoop = true;
  }

  var productImageSlider = $('#product-image-slider');
  if(productImageLoop) {
    productImageSlider.owlCarousel({
      nav:false,
      items:1,
      loop: productImageLoop,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplaySpeed: 750,
      dots: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      navText: ['<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>','<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>'],
                })
                }

                jQuery(document).on('click','.product-thumbs-list li a', function( event ){4
                event.preventDefault();
                var reqIndex = jQuery(this).parent('li').index();
                productImageSlider.trigger('to.owl.carousel',[reqIndex]);
    });



    // BX SLIDERS
    jQuery('.product-thumbs-list').each( function(){
      if($(this).find('.product-thumbs-item').length >=4 ) {
        jQuery(this).bxSlider({
          mode: 'horizontal',
          slideWidth: '150',
          maxSlides: 4,
          moveSlides :1,
          pager: false,
          responsize: false,
          infiniteLoop: false,
          hideControlOnEnd: true,
          prevText: '<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>',
          nextText: '<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>'
        });
      }

    });


    /* PARALLAX  */
    // init ScrollMagic Parallax Scenes
//     var controller = new ScrollMagic.Controller();
//     if( jQuery('#hero-slider.has-parallax').length > 0 ){
//       new ScrollMagic.Scene({
//         duration: '100%',
//         triggerElement: '#hero-slider',
//         triggerHook: 0,
//         offset: '-100px',
//       })
//       .setTween(
//         TweenMax.fromTo('.slide-image', 1, {
//           y: '0'
//         }, {
//           y: '-10%'
//         })
//       )
//       .addTo(controller);   
//     }



    /* ZOOM EFFECT  */
//     var evt = new Event();
//     m = new Magnifier(evt); 
//     m.attach({
//       thumb: '.zoomable-image',
//       mode: 'inside',
//       zoom: 2,
//       zoomable: true
//     });










    /* AJAX COLLECTION
	===============================================*/

    // Set all neccesary variables
    var ajaxProducts = [];

    // load collection 
    function loadCollection(reqCollection){
      jQuery.ajax({
        url: shopUrl+"/pages/products-json?collection="+reqCollection+"&cache=false",
        type: "GET",
        success: function( data ){
          console.log('ajax sucess: '+JSON.stringify(data));
          var ajaxResponse =  JSON.parse( data );
          ajaxProducts = ajaxResponse['products'];
          filterProducts();
        },
        error: function( data ) {
          console.log('ajax error: '+JSON.stringify(data));
          jQuery('.products-list').html('<li>No items match your filter criteria.</li>');
        },
        complete: function( data ) {
          console.log('ajax complete');
          jQuery('#loading').addClass('loaded');
        }
      })
    }

    // if variable "collectionToLoad" exists, load the collection
    // "collectionToLoad" is set in the collection.liquid template
    if( typeof collectionToLoad != 'undefined' ){
      // loadCollection(collectionToLoad);
    }


    /* PRODUCT LIST
	===============================================*/

    // Set all neccesary variables
    var initialPageLoad = true;
    var initialLocation = window.location;
    var filteredProducts = [];
    var bankSize = 20;
    var listView = 'bank';
    var productPagesIndex = 1;
    var productPages;
    var bankStartIndex;
    var bankEndIndex;
    var minPrice = 0;
    var maxPrice = 1500;
    var lowPriceRange = minPrice;
    var hiPriceRange = maxPrice;
    var dhsRate = 1;
    var conditionsArray = [];
    var conditionsString = '';
    var colorConditionsArray = [];
    var sizeConditionsArray = [];
    var typeConditionsArray = [];
    var selectedFilters = {
      color : [],
      size : [],
      type: []
    };
    var collectionSorting;
    var paginationIndex = 1;
    var paginationBankSize = 5;


    // Price Slider
    jQuery( "#slider" ).slider({
      step: 1,
      range: true,
      values: [ minPrice, maxPrice ],
      min: minPrice,
      max: maxPrice,
      slide: function( event, ui ) {
        handleSliderChange( event, ui );
      },
      stop: function( event, ui ) {
        handleSliderDone( event, ui );
      }
    });


    // check for url filter parameters
    function getQueryVariable(variable)
    {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }


    // set selected checkboxes to checked
    for( filter in selectedFilters ){
      if( getQueryVariable(filter) ){
        var filterItems = getQueryVariable(filter).split(',');
        for( var x = 0 ; x < filterItems.length ; x++ ){
          console.log( filter+' array index '+x+':'+ filterItems[x] );
          jQuery('input#tag-'+filterItems[x]).prop('checked', true);
        }   
      }
    }


    // set price filters
    if( getQueryVariable('price') ){
      var priceRange = getQueryVariable('price').split(',');
      lowPriceRange = priceRange[0];
      hiPriceRange  = priceRange[1];
      // console.log( 'url price range: '+lowPriceRange+' - '+hiPriceRange );
      $( "#slider" ).slider( "option", "values", [ lowPriceRange, hiPriceRange ] );
    }


    // set sort filters
    if( getQueryVariable('sort_by') ){
      collectionSorting = getQueryVariable('sort_by');
    } else {
      // defaultCollectionSorting variable is being set on collection.liquid
      if( typeof defaultCollectionSorting != 'undefined' ){
        collectionSorting = defaultCollectionSorting;
      }
    }


    //     $('#SortBy')
    //         .val(collectionSorting)
    //         .bind('change', function() {
    //             location.search = filterUrlParams( jQuery(this).val() );
    //         }
    //     );    


    // check if page is set
    if( getQueryVariable('p') ){
      productPagesIndex = parseInt(getQueryVariable('p'));
    }


    // If product array exists, print product list
    if( typeof collectionProducts != 'undefined' ){
      if( collectionProducts.length > 0 ){
        ajaxProducts = collectionProducts;
        filterProducts();
      } else {
        jQuery('.products-list').html('<li>No items match your filter criteria.</li>');
      }
    } 



    // Set all neccesary filters
    function setFilters() {

      // clear variables
      conditionsArray = [];
      colorConditionsArray = [];
      sizeConditionsArray = [];
      typeConditionsArray = [];

      conditionsString = '';
      for( filter in selectedFilters ){
        selectedFilters[filter] = [];
      }

      // Checkbox filters
      jQuery("input[type=checkbox]:checked").each(function() {
        // get checkbox filter type
        var filterType = jQuery(this).attr('name');
        console.log('filterType:'+filterType);
        switch( filterType ){
          case 'color':
            colorConditionsArray.push("ajaxProducts[x].tags.search( /" + jQuery(this).val() + "/i )!==-1");
            break;
          case 'size':
            sizeConditionsArray.push("ajaxProducts[x].tags.search( /" + jQuery(this).val() + "/i )!==-1");
            break;
          case 'type':
            typeConditionsArray.push("ajaxProducts[x].tags.search( /" + jQuery(this).val() + "/i )!==-1");
            break;
        }
        // push into arrays in the selected filters object
        selectedFilters[filterType].push(jQuery(this).val());
      }); 



      // Take all conditions in conditionsArray and add them to the "conditionsString" string

      // color conditions
      if( colorConditionsArray.length > 0 ) {
        var joinedColors = colorConditionsArray.join(' || ');
        conditionsString += '( ' + joinedColors + ' )';
      }

      // size conditions
      if( sizeConditionsArray.length > 0 ) {
        var joinedSizes = sizeConditionsArray.join(' || ');
        conditionsString += ( conditionsString !== '' ? ' && ' : '')+'( ' + joinedSizes + ' )';
      }

      // type conditions
      if( typeConditionsArray.length > 0 ) {
        var joinedTypes = typeConditionsArray.join(' || ');
        conditionsString += ( conditionsString !== '' ? ' && ' : '')+'( ' + joinedTypes + ' )';
      }

      // add price condition
      conditionsString += ( conditionsString !== '' ? ' && ' : '') + '( ( parseInt(ajaxProducts[x].price) / 100 ) >= lowPriceRange && ( parseInt(ajaxProducts[x].price) / 100 ) <= hiPriceRange )';

      // comment to view final conditionsString
      // console.log("Condition to eval: " + conditionsString);
    }


    // Print product list
    function filterProducts() {
      // console.log('filterProducts()');

      // init variables
      filteredProducts = [];

      // run function that sets the selected filters
      setFilters();

      // add products to filtered list
      if (conditionsString === '') {
        // no filters, add all to filtered array
        for (var x = 0; x < ajaxProducts.length; x++) {
          filteredProducts.push( ajaxProducts[x] );
        }
      } else {
        // has filtering, add matched to filtered array
        for (var x = 0; x < ajaxProducts.length; x++) {
          if (eval(conditionsString)) {
            // passes filering, push into filteres items array
            filteredProducts.push( ajaxProducts[x] );
          }
        }
      }

      renderProducts( filteredProducts );

    }


    // Render list HTML
    var historyStateArray;
    function renderProducts( filteredProducts ){

      historyStateArray = [];

      // get array count
      filteredProductsCount = filteredProducts.length;

      // set start and end indexes
      if( listView == 'bank' ){

        // calculate pages
        productPages = Math.ceil(filteredProductsCount / bankSize);
        paginationPages = Math.ceil(productPages / paginationBankSize);
        // console.log('paginationPages:'+paginationPages);

        // set pagination bank start and end
        paginationBankStartIndex = ( paginationBankSize * paginationIndex ) - paginationBankSize;
        paginationBankEndIndex = paginationBankStartIndex + paginationBankSize - 1 ;
        if( paginationBankStartIndex < 1 ){
          paginationBankStartIndex = 1;
        }

        // adjust from 0 index
        paginationBankStartIndex++;
        paginationBankEndIndex++;

        // limit end index if larger that pages
        if( paginationBankEndIndex >= productPages - 1 ){
          paginationBankEndIndex = productPages - 1;
        }            

        // console.log('bank:'+paginationBankSize+', paginationIndex:'+paginationIndex+', StartIndex:'+paginationBankStartIndex+', EndIndex:'+paginationBankEndIndex);

        // setup pagination links
        jQuery('.product-list-pages .pages').html('');
        if( productPages > 1){

          // show nav
          jQuery('.product-list-pages').addClass('active');
          // show prev button if needed
          if ( productPagesIndex > 1 ){
            jQuery('.product-list-pages .prev').addClass('visible');
          } else {
            jQuery('.product-list-pages .prev').removeClass('visible');
          }

          // append page link buttons
          if( productPages > 1 ){
            // append pagination prev ellipsis
            jQuery('.product-list-pages .pages').append('<a href="#" class="visible page-link'+(productPagesIndex == 1 ? " active current" : "")+'" data-page="1" data-pagination-index="1">1</a><a href="#" class="pagination-prev visible">...</a>');

            // append bank pages
            for (pageX = paginationBankStartIndex; pageX <= paginationBankEndIndex; pageX++) {
              jQuery('.product-list-pages .pages').append('<a href="#" class="visible page-link'+(productPagesIndex == pageX ? " active current" : "")+'" data-page="'+pageX+'" data-pagination-index="'+paginationIndex+'">'+pageX+'</a>');
            }

            // append pagination next ellipsis
            jQuery('.product-list-pages .pages').append('<a href="#" class="pagination-next">...</a><a href="#" class="visible page-link'+(productPagesIndex == productPages ? " active current" : "")+'" data-page="'+productPages+'" data-pagination-index="'+paginationPages+'">'+productPages+'</a>');

          }

          // handle ellipsis
          if ( paginationIndex > 1 ){
            jQuery('.product-list-pages .pagination-prev').addClass('visible');
          } else {
            jQuery('.product-list-pages .pagination-prev').removeClass('visible');
          }
          if ( paginationIndex == paginationPages ){
            jQuery('.product-list-pages .pagination-next').removeClass('visible');
          } else {
            jQuery('.product-list-pages .pagination-next').addClass('visible');
          }



          // show next button if needed
          if ( productPagesIndex < productPages ){
            jQuery('.product-list-pages .next').addClass('visible');
          } else {
            jQuery('.product-list-pages .next').removeClass('visible');
          }
        } else {
          // hide nav
          jQuery('.product-list-pages').removeClass('active');
        }

        // paginate, 
        bankStartIndex = ( bankSize * productPagesIndex ) - bankSize;
        bankEndIndex = bankStartIndex + bankSize - 1 ;
        // if bankEndIndex larger that item count, adjust
        if( bankEndIndex >= filteredProductsCount - 1 ){
          bankEndIndex = filteredProductsCount - 1;
        }
      } else {
        // no pagination
        bankStartIndex = 0;
        bankEndIndex = filteredProductsCount-1;
        // set current page to 1, so indexing works from 1
        productPagesIndex = 1;
      }

      // console.log('renderProducts() in '+listView+' mode, index:'+bankStartIndex+' - '+bankEndIndex+' of '+productPages+' pages.');

      // print items html
      var listHtml = '';
      for ( x = bankStartIndex ; x <= bankEndIndex ; x++ ) {
        if ( filteredProducts[x] ){
          listHtml += productHtml( filteredProducts[x] );
        }
      }

      if( listHtml !== '' ){
        jQuery('.products-list').html(listHtml);
        // convert currency
        Currency.convertAll(shopCurrency, Currency.currentCurrency );
        jQuery('.grid-link__sale_price .money').addClass('visible');

        swymLoadBtns();

        // set history state text
        for( filter in selectedFilters ){
          if( selectedFilters[filter].length > 0){
            // console.log(filter+'='+selectedFilters[filter].join(','));
            historyStateArray.push(filter+'='+selectedFilters[filter].join(','));
          }
        }

        history.pushState(null,null,filterUrlParams( collectionSorting ));

      } else {
        jQuery('.products-list').html('<li>No items match your filter criteria.</li>');
      }

    }

    // returns all filter URL parameters
    function filterUrlParams( sortingType ) {
      return '?price='+lowPriceRange+','+hiPriceRange+( historyStateArray.length > 0 ? '&' + historyStateArray.join('&') : '' ) + ( productPagesIndex > 1 ? '&p='+productPagesIndex : '' ) + ( sortingType ? '&sort_by='+sortingType : '' );
    }

    // Swym start

    function swymLoadBtns(){
      if(window._swat){
        renderSwymBtns();
      }else{
        window.SwymCallbacks = window.SwymCallbacks || [];
        SwymCallbacks.push(function(){
          renderSwymBtns();
        });
      }
    }

    function renderSwymBtns(){
      _swat.initializeActionButtons(".product-list");
    }

    //Swym end



    // product html template
    function productHtml( product ){
      var itemHTML = '';
      itemHTML += '<li class="product-list-item"><a class="product-list-link" href="'+product.url+'">';
      itemHTML += '<span class="product-image'+( product.soldOut ? ' sold-out' : '' )+'"><span class="image" style="background-image: url('+product.image+');"></span>';
      itemHTML += product.onSale ? '<span class="product-badge on-sale"><span class="text">'+product.onSaleText+'</span></span>' : '';
      itemHTML += product.soldOut ? '<span class="product-badge sold-out"><span class="text">'+product.soldOutText+'</span></span>' : '';
      itemHTML += '</span>';
      itemHTML += '<span class="product-name">'+product.title+'</span>';
      itemHTML += '<span class="product-price">';
      itemHTML += product.onSale ? '<s class="grid-link__sale_price"><span class="money">'+product.comparePrice+'</span></s> ' : '';
      itemHTML += product.priceVaries ? product.priceVariationText+' ' : ' ';
      itemHTML += '<span class="money visible">'+Math.round(product.price)+'</span>';
      itemHTML += '</span>';
      itemHTML += '<span class="product-button">Buy Now</span>';
      itemHTML += '<button class="swym-button swym-add-to-wishlist-view-product product_'+product.id+'" data-swaction="addToWishlist" data-product-id="'+product.id+'"></button>';
      itemHTML += '</a></li>';
      return itemHTML;
    }

    // reset pagination index
    function setPaginationIndex(){
      paginationIndex = Math.ceil(productPagesIndex / paginationBankSize);
      console.log('setPaginationIndex(): '+paginationIndex);
    }


    // product list nav page click
    //     jQuery(document).on('click', '.product-list-pages a', function(event){
    //         event.preventDefault();
    //       $('html').animate({scrollTop:0}, 'fast');//IE, FF
    //       $('body').animate({scrollTop:0}, 'fast');//chrome, don't know if Safari works
    //         var thisButton = jQuery(this);

    //         if( thisButton.hasClass('visible') ){
    //             if( thisButton.hasClass('next') ){
    //                 productPagesIndex ++;
    //                 setPaginationIndex()
    //             }
    //             if( thisButton.hasClass('prev') ){
    //                 productPagesIndex --;
    //                 setPaginationIndex()
    //             }
    //             if( thisButton.hasClass('page-link') ){
    //                 productPagesIndex = thisButton.attr('data-page');
    //                 setPaginationIndex()
    //             }
    //             if( thisButton.hasClass('pagination-next') ){
    //                 paginationIndex ++;
    //             }
    //             if( thisButton.hasClass('pagination-prev') ){
    //                 paginationIndex --;
    //             }
    //             filterProducts();
    //         }
    //     });


    // form checkbox change
    jQuery(document).on('change keyup paste','.js-product-filters input[type="checkbox"]',function(event){
      event.preventDefault();
      productPagesIndex = 1;
      filterProducts();
    }); 


    // all filters visibility toggle
    jQuery(document).on('click','.collection-filters-heading',function( event ){
      event.preventDefault();
      jQuery('.collection-filters-wrapper').toggleClass('active');
    });


    // filter group visibility toggle
    jQuery(document).on('click','.filter-checkbox-label',function( event ){
      event.preventDefault();
      jQuery(this).closest('.filter-checkbox-group').toggleClass('active');
    });


    // slider change
    function handleSliderChange( event, ui ){
      updatePriceRange( ui.values[0] , ui.values[1] );
    }


    // slider stopped
    function handleSliderDone( event, ui ){
      lowPriceRange = ui.values[0];
      hiPriceRange = ui.values[1];
      filterProducts();
    }

    // updates price range
    function updatePriceRange( lowPrice , hiPrice ){
      // get currency, make it a class

      //       var currencyClass = Currency.currentCurrency.toLowerCase();
      var currencyClass = theme.shop_currency.toLowerCase();


      // apply currency class
      jQuery('.price-range').attr( 'class' , 'price-range '+currencyClass);

      // get prices
      var lowPriceUsd = lowPrice;
      var lowPriceDhs = Math.floor( lowPriceUsd * dhsRate );
      var hiPriceUsd = hiPrice;
      var hiPriceDhs = Math.floor( hiPriceUsd * dhsRate );

      // render prices
      jQuery('.price-range .min-price .usd').text(lowPriceUsd);
      jQuery('.price-range .min-price .aed').text(lowPriceDhs);
      jQuery('.price-range .max-price .usd').text(hiPriceUsd);
      jQuery('.price-range .max-price .aed').text(hiPriceDhs);
    }

    updatePriceRange( lowPriceRange , hiPriceRange);










    /* AJAX MAILCHIMP
	===============================================*/

    //     jQuery('#mc-embedded-subscribe-form').ajaxChimp();









    /* DISCOUNT OVERLAY
	===============================================*/

    function discountOverlay(){

      var discountCookie = readCookie('discountCookie');
      var search_attr = window.location.search.substr(1);
      //console.log(discountCookie);

      if( !discountCookie && search_attr != "e=n"){
        setTimeout( function(){
          openDiscountOverlay();
          createCookie('discountCookie','true',14);

        } , 4000);
      } 
    }

    function homePagePopupOverlay(){

      var homepagePopupCookie = readCookie('homepagePopupCookie');
      var search_attr = window.location.search.substr(1);


      if( !homepagePopupCookie && search_attr != "e=n"){
        setTimeout( function(){
          openHomepagePopupOverlay();

          createCookie('homepagePopupCookie','true',14);

        } , 4000);
      } 
    }



    function openDiscountOverlay(){
      openOverlay('discount');
    }
    
    function openHomepagePopupOverlay(){
      openHomePagePopupOverlay('discount');
    }


    function discountHtml(){
      //         return '<div id="discount-overlay"><div class="logo">'+bloomrLogo+'</div><div class="flex-wrapper"><div class="flex-column flex-column-50 membership-column"><h1 class="discount-heading">Interior Design<span>Obsessed?</span></h1><h2 class="discount-sub-heading">Join the BLOOMR VIP Program and enjoy:</h2><div class="discount-amount">25% Off</div><div class="discount-details">Everything, Always.<br>Free Shipping, Always.</div><div class="discount-button-heading">Ready To Be A BLOOMR VIP?</div><a href="'+shopUrl+'/pages/membership" class="discount-button">Join Today</a><div class="discount-small-type">For an annual fee of $100</div></div><div class="flex-column flex-column-50 sign-up-column"><h1 class="discount-heading">Interior Design<span>Lover?</span></h1><h2 class="discount-sub-heading">Sign up for inspiring interior updateds and enjoy:</h2><div class="discount-amount">10% Off</div><div class="discount-details">Your first purchase.<br>New customers only.<br>Free shipping on orders over $150.</div><div class="discount-button-heading">Ready To Be Inspired?</div><form action="/contact#contact_form" method="post" id="mc-embedded-subscribe-form-overlay" class=""><input type="hidden" value="customer" name="form_type"><input type="hidden" name="contact[tags]" value="newsletter"><div><input type="email" value="" placeholder="Enter Email" name="contact[email]" id="Email" aria-label="Enter Email" autocorrect="off" autocapitalize="off"><button type="submit" class="discount-button" name="subscribe" id="subscribe" value="Unlock Offer">Submit</button></div><label for="mc-email" class="mc-messages"></label></form><a href="#" class="discount-button sign-up-button">Sign Up</a><div class="discount-small-type">&nbsp;</div></div></div><a href="#" class="discount-continue">Not ready to be inspired? Continue ></a></div>';
      return  '<div id="discount-overlay">'
      +'<a href="#" class="overlay-close"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><polygon points="517.871,501.189 669.135,300 635.129,300 499.699,480.009 364.268,300 330.866,300 481.526,501.189 325,700 	357.256,700 499.699,521.188 642.748,700 675,700 "></polygon></svg></a>'
      +'<div class="logo">'+bloomrLogo+'</div>'
      +' <div class="flex-wrapper">'
      +'  <div class="flex-column  membership-column">'
      +' <h1 class="discount-heading">Savings in full bloom! </h1>'
      +'   <h2 class="discount-sub-heading">Sign Up For 10% Off</h2>'
      +'  <div class="discount-amount"> 10% Off </div>'
      +'   <div class="discount-details">FREE Shipping<br>Additional 7 days for returns</div>'
      +' <form action="https://manage.kmail-lists.com/subscriptions/subscribe?a=KTwi6M&g=M2vPzM" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"  novalidate>'
      +'   <input type="hidden" value="customer" name="form_type">'
      +' <input type="hidden" name="contact[tags]" value="newsletter">'
      +'   <div class="popap_join_form">'
      +' <div class="popap_field"> <input type="email" value="" placeholder="Enter Your Email" name="EMAIL" id="mce-EMAIL" aria-label="Enter Email" autocorrect="off" autocapitalize="off" class="required email"></div>'
      +'<div class="popap_field"><button type="submit" class="discount-button" name="subscribe" id="subscribe" value="Unlock My Offer">Unlock My Offerr</button></div>'
      + '   </div>'
      +' <label for="mc-email" class="mc-messages"></label>'
      +' </form>'
      +'</div>'
      +'</div>'
      +'</div>';

    }

        function home_page_popup_Html(){
      return  '<div id="home_page_popup_overlay">' 
      +'<a href="#" class="overlay-close"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><polygon points="517.871,501.189 669.135,300 635.129,300 499.699,480.009 364.268,300 330.866,300 481.526,501.189 325,700 	357.256,700 499.699,521.188 642.748,700 675,700 "></polygon></svg></a>'
      +'<div class="logo">'+ bloomrLogo +'</div>'
      +' <div class="flex-wrapper">'
      +'  <div class="flex-column  membership-column">'
      +' <h1 class="home_page_popup_heading">Savings in full bloom! </h1>'
      +'   <h2 class="home_page_popup_sub-heading">Sign Up for early access to new products, exclusive offers, and</h2>'
      +'  <div class="home_page_popup-amount"> 10% </div>'
      +'   <div class="home_page_popup-details"> your first order </div>'
      +' <form action="https://manage.kmail-lists.com/subscriptions/subscribe?a=KTwi6M&g=M2vPzM" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"  novalidate>'
      +'   <input type="hidden" value="customer" name="form_type">'
      +' <input type="hidden" name="contact[tags]" value="newsletter">'
      +'   <div class="popap_join_form">'
      +' <div class="popap_field"> <input type="email" value="" placeholder="Enter email address" name="EMAIL" id="mce-EMAIL" aria-label="Enter Email" autocorrect="off" autocapitalize="off" class="required email"></div>'
      +'<div class="popap_field"><button type="submit" class="home_page_popup-button" name="subscribe" id="subscribe" value="submit">submit</button></div>'
      + '   </div>'
      +' <label for="mc-email" class="mc-messages"></label>'
      +' </form>'
      +'</div>'
      +'</div>'
      +'</div>';

    }



    // reveal signup form
    jQuery(document).on('click','#discount-overlay .sign-up-button',function(event){
      event.preventDefault();
      jQuery('#discount-overlay .sign-up-column').addClass('show-form');
    });

    // close overlay 3 seconds after successfull signup
    function discountOverlaySignup(resp){
      if (resp.result === 'success') {
        setTimeout( function(){
          closeOverlay();
        } , 3000);
      }
    }

    /* ON INIT */
    //checkRegionalSettings();

  });


  // GET WINDOW LOCATION
  var windowLocation = window.location.href;


  // COOKIE CODE
  function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    createCookie(name,"",-1);
  }



  var loaderInterval = 10;
  var loadingTimeLimit = 4000;
  var loadingTime = 0;

  var everythingLoaded = setInterval(function() {
    if (/loaded|complete/.test(document.readyState) || loadingTime > loadingTimeLimit) {
      clearInterval(everythingLoaded);
      jQuery('body').addClass('loaded');
    }
    loadingTime += loaderInterval;
  }, loaderInterval);



  // INCLUDES METHOD POLYFILL
  if (!String.prototype.includes) {
    String.prototype.includes = function() {
      'use strict';
      return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
  }

  $(document).ready(function() {

    var imageHoverTimeout;
    $('.image-hover-link').hover( function() {   
      clearTimeout(imageHoverTimeout);
      var thisWrapper = $(this).closest('.sub-menu-main-image-wrapper');
      var thisImage = $(this).data('image-url');

      thisWrapper.find('.sub-menu-image').css('background-image', 'url(' + thisImage + ')');
    },
                                 function() {  
      var thisWrapper = $(this).closest('.sub-menu-main-image-wrapper');
      var defaultImage = thisWrapper.find('.sub-menu-image').data('default-image');            
      imageHoverTimeout = setTimeout( function(){
        thisWrapper.find('.sub-menu-image').css('background-image', 'url(' + defaultImage + ')');
      } , 500);
    }
                                );
  });
  $(document).ready( function () {
    $('.header-search-field-wrapper a').magnificPopup({
      type: 'inline',
      "mainClass": "white_search_popup",
      focus: ".input-group-field",
    });  
    $('.mobile_header_search_btn').magnificPopup({
      type: 'inline',
      "mainClass": "white_search_popup",
      focus: ".input-group-field",
      callbacks: {
        open: function() {
          var overlay = jQuery('.mobile-navigation-container');
          var overlayInner = jQuery('.mobile-navigation-inner');

          // setup body
          jQuery('body').toggleClass('mobile-navigation');
          // show overlay & inner
          overlay.removeClass('active');
          overlayInner.removeClass('active');

          $("#search_popup .input-group-field").focus();
        }
      }
    });  
  });


  $(document).ready( function () {
    
    if($(window).width() < 769){
     $(".header-columns").append($(".cart-summary-modal")); 
    }
    
    $(window).on("resize", function(){
      if($(window).width() < 769){
        $(".header-columns").append($(".cart-summary-modal")); 
      }else{
        $(".modal_cart_container").append($(".cart-summary-modal")); 
      }
    });
    
    
    $('body').on('click', '.btn_to_form', function(e) {
      e.preventDefault();
      var id  = $(this).attr('href'),
          top = $(id).offset().top - 30;
      console.log(top);
      $('body,html').animate({scrollTop: top}, 1500);
    });
    
    $('body').on('click', '.continue_shopping_drawer, .added-notice__close', function(e) {
       $(".cart-summary-drawer").fadeOut(200).delay(200).remove();
       $(".cart-summary-modal").fadeOut(200);
       window.setTimeout(function(){
            $(".cart-summary-modal").removeAttr("style");
          }, 300);
       
     });
    
    $('.langing_carousel_wrapper').owlCarousel({
      nav:true,
      responsive:{
        0:{
          items:1
        },
        768:{
          items:2
        },
        1024:{
          items:3
        }
      },
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplaySpeed: 750,
      navText: ['<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-left.png?v=28406240592392335921651590555"/>','<img src="//www.bloomr.com/cdn/shop/t/99/assets/product-slider-arrow-right.png?v=87071194193309311061651590556"/>']
                });     

                var currentAjaxRequest = null;
                var searchForms = $('#search_popup form[action="/search"], #search_popup form[action="/ar/search"]').css('position','relative').each(function() {   
                var input = $(this).find('input[name="q"]');   
                $('<span class="search-results-product-title">Products</span>').appendTo($(this)).hide();              
                $('<ul class="search-results"></ul>').appendTo($(this)).hide();    
                input.attr('autocomplete', 'off').bind('keyup change', function() {     
                var term = $(this).val();      
                var form = $(this).closest('form');  
                var action = form.attr("action");
                var searchURL = action+'?type=product&q=' + term;   
                var resultsList = form.find('.search-results');
                var resultsTitle = form.find('.search-results-product-title');
                if (term.length > 3 && term != $(this).attr('data-old-term')) {       
                $(this).attr('data-old-term', term);       
                if (currentAjaxRequest != null) currentAjaxRequest.abort();      
                currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {       
                resultsList.empty();
                if(data.results_count == 0) {            
                resultsList.hide();
                } else {           
                $.each(data.results, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);              
                link.append('<span class="title">' + item.title + '</span>');
                link.wrap('<li></li>');
                resultsList.append(link.parent());              
                });   
                $(".search-results .title").each(function(){
                var newText = $(this).html().toLowerCase().replace(term.toLowerCase(), "<strong>"+term.toLowerCase()+"</strong>");
                $(this).html(newText);    
                });
                //               .html(function(_, html) { return html.split(term).join("<span class='smallcaps'>"+term+</span>");});
                if(data.results_count > 50) {
                resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
                }
                resultsList.fadeIn(200);
                resultsTitle.fadeIn(200);
                }        
                });
                }
                });
                });

                //   $('body').bind('click touchend', function(){
                //     $('.search-results').hide();
                //   });   


                });



                $(document).ready(function () {

                var footer_btn =   $('.site-footer-bk').find('#subscribe');
                $( window ).resize(function() {
                if($(window).width() < 800) {
                footer_btn.val('SUBSCRIBE');
                } else {
                footer_btn.val('SUBMIT');
                }
                });

                });